module.exports = __webpack_public_path__ + "static/media/plus_icon.acbbf446.svg";